export default __webpack_public_path__ + "static/media/CR_logo.64b8e4c5.png";